/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CrossOrgProcessedSubscriptionPaginatedResponse } from '../model/crossOrgProcessedSubscriptionPaginatedResponse';
// @ts-ignore
import { ProcessedSubscriptionPaginatedResponse } from '../model/processedSubscriptionPaginatedResponse';
// @ts-ignore
import { ProcessedSubscriptionPatchSpec } from '../model/processedSubscriptionPatchSpec';
// @ts-ignore
import { ProcessedSubscriptionPostSpec } from '../model/processedSubscriptionPostSpec';
// @ts-ignore
import { ProcessedSubscriptionResponse } from '../model/processedSubscriptionResponse';
// @ts-ignore
import { RawSubscriptionV4DeleteSpec } from '../model/rawSubscriptionV4DeleteSpec';
// @ts-ignore
import { RawSubscriptionV4PaginatedResponse } from '../model/rawSubscriptionV4PaginatedResponse';
// @ts-ignore
import { RawSubscriptionV4PatchSpec } from '../model/rawSubscriptionV4PatchSpec';
// @ts-ignore
import { RawSubscriptionV4PostSpec } from '../model/rawSubscriptionV4PostSpec';
// @ts-ignore
import { RawSubscriptionV4Response } from '../model/rawSubscriptionV4Response';
// @ts-ignore
import { SubscriptionDisplay } from '../model/subscriptionDisplay';
// @ts-ignore
import { SubscriptionDisplayCreationPostSpec } from '../model/subscriptionDisplayCreationPostSpec';
// @ts-ignore
import { SubscriptionDisplayPaginatedResponse } from '../model/subscriptionDisplayPaginatedResponse';
// @ts-ignore
import { SubscriptionDisplayUpdatePatchSpec } from '../model/subscriptionDisplayUpdatePatchSpec';
// @ts-ignore
import { SubscriptionHistory } from '../model/subscriptionHistory';
// @ts-ignore
import { SubscriptionHistoryCreationPostSpec } from '../model/subscriptionHistoryCreationPostSpec';
// @ts-ignore
import { SubscriptionHistoryPaginatedResponse } from '../model/subscriptionHistoryPaginatedResponse';
// @ts-ignore
import { SubscriptionHistoryUpdatePatchSpec } from '../model/subscriptionHistoryUpdatePatchSpec';
// @ts-ignore
import { SubscriptionStateEnum } from '../model/subscriptionStateEnum';
// @ts-ignore
import { SubscriptionTypeEnumV2 } from '../model/subscriptionTypeEnumV2';
// @ts-ignore
import { Tenant } from '../model/tenant';
// @ts-ignore
import { TenantCreationPostSpec } from '../model/tenantCreationPostSpec';
// @ts-ignore
import { TenantPaginatedResponse } from '../model/tenantPaginatedResponse';
// @ts-ignore
import { TenantUpdatePatchSpec } from '../model/tenantUpdatePatchSpec';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BillingSubscriptionOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Cancel a subscription in billing erp by serial number
     * Cancel a subscription in billing erp by serial number
     * @param serialNumber Serial number
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cancelSubscriptionOperator(serialNumber: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public cancelSubscriptionOperator(serialNumber: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public cancelSubscriptionOperator(serialNumber: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public cancelSubscriptionOperator(serialNumber: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (serialNumber === null || serialNumber === undefined) {
            throw new Error('Required parameter serialNumber was null or undefined when calling cancelSubscriptionOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumber, 'serialNumber');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/cancel`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a subscription display.
     * Create a subscription display.
     * @param subscriptionDisplayCreationPostSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSubscriptionDisplayOperator(subscriptionDisplayCreationPostSpec?: SubscriptionDisplayCreationPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionDisplay>;
    public createSubscriptionDisplayOperator(subscriptionDisplayCreationPostSpec?: SubscriptionDisplayCreationPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionDisplay>>;
    public createSubscriptionDisplayOperator(subscriptionDisplayCreationPostSpec?: SubscriptionDisplayCreationPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionDisplay>>;
    public createSubscriptionDisplayOperator(subscriptionDisplayCreationPostSpec?: SubscriptionDisplayCreationPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/display`;
        return this.httpClient.request<SubscriptionDisplay>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: subscriptionDisplayCreationPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a subscription history.
     * Create a subscription history.
     * @param subscriptionHistoryCreationPostSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSubscriptionHistoryOperator(subscriptionHistoryCreationPostSpec?: SubscriptionHistoryCreationPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionHistory>;
    public createSubscriptionHistoryOperator(subscriptionHistoryCreationPostSpec?: SubscriptionHistoryCreationPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionHistory>>;
    public createSubscriptionHistoryOperator(subscriptionHistoryCreationPostSpec?: SubscriptionHistoryCreationPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionHistory>>;
    public createSubscriptionHistoryOperator(subscriptionHistoryCreationPostSpec?: SubscriptionHistoryCreationPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/history`;
        return this.httpClient.request<SubscriptionHistory>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: subscriptionHistoryCreationPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a tenant.
     * Create a tenant.
     * @param tenantCreationPostSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTenantOperator(tenantCreationPostSpec?: TenantCreationPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Tenant>;
    public createTenantOperator(tenantCreationPostSpec?: TenantCreationPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Tenant>>;
    public createTenantOperator(tenantCreationPostSpec?: TenantCreationPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Tenant>>;
    public createTenantOperator(tenantCreationPostSpec?: TenantCreationPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/tenant`;
        return this.httpClient.request<Tenant>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tenantCreationPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Clear all V4 VMware raw subscriptions
     * Truncate V4 VMware raw subscription table to clear all data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteAllV4RawSubscriptionsOperator(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteAllV4RawSubscriptionsOperator(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteAllV4RawSubscriptionsOperator(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteAllV4RawSubscriptionsOperator(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/v4/raw-subscription/truncate-table`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete billing processed subscription by id
     * Delete billing processed subscription by id
     * @param processedSubscriptionQueryId Processed Subscription Primary Key
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteProcessedSubscription(processedSubscriptionQueryId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProcessedSubscriptionResponse>;
    public deleteProcessedSubscription(processedSubscriptionQueryId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProcessedSubscriptionResponse>>;
    public deleteProcessedSubscription(processedSubscriptionQueryId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProcessedSubscriptionResponse>>;
    public deleteProcessedSubscription(processedSubscriptionQueryId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (processedSubscriptionQueryId === null || processedSubscriptionQueryId === undefined) {
            throw new Error('Required parameter processedSubscriptionQueryId was null or undefined when calling deleteProcessedSubscription.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>processedSubscriptionQueryId, 'processed-subscription-query-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/processed-subscription`;
        return this.httpClient.request<ProcessedSubscriptionResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a subscription display.
     * Delete a subscription display.
     * @param id Generic long id identifier in the path
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSubscriptionDisplayOperator(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteSubscriptionDisplayOperator(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteSubscriptionDisplayOperator(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteSubscriptionDisplayOperator(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteSubscriptionDisplayOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/display/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a subscription history.
     * Delete a subscription history.
     * @param id Generic long id identifier in the path
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSubscriptionHistoryOperator(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteSubscriptionHistoryOperator(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteSubscriptionHistoryOperator(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteSubscriptionHistoryOperator(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteSubscriptionHistoryOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/history/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a tenant.
     * Delete a tenant.
     * @param id Generic long id identifier in the path
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTenantOperator(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteTenantOperator(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteTenantOperator(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteTenantOperator(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteTenantOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/tenant/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete v4 raw subscription by id and data source
     * Delete v4 subscription by id and data source
     * @param rawSubscriptionV4DeleteSpec V4 raw subscription delete Spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteV4RawSubscriptionOperator(rawSubscriptionV4DeleteSpec: RawSubscriptionV4DeleteSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RawSubscriptionV4Response>;
    public deleteV4RawSubscriptionOperator(rawSubscriptionV4DeleteSpec: RawSubscriptionV4DeleteSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RawSubscriptionV4Response>>;
    public deleteV4RawSubscriptionOperator(rawSubscriptionV4DeleteSpec: RawSubscriptionV4DeleteSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RawSubscriptionV4Response>>;
    public deleteV4RawSubscriptionOperator(rawSubscriptionV4DeleteSpec: RawSubscriptionV4DeleteSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rawSubscriptionV4DeleteSpec === null || rawSubscriptionV4DeleteSpec === undefined) {
            throw new Error('Required parameter rawSubscriptionV4DeleteSpec was null or undefined when calling deleteV4RawSubscriptionOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/v4/raw-subscription`;
        return this.httpClient.request<RawSubscriptionV4Response>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rawSubscriptionV4DeleteSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all subscription display.
     * Get all subscription display.
     * @param sortBy Sort the subscription display by this column
     * @param sortByOrder Sort the properties by this order
     * @param idOptionalQueryParam Long ID query param
     * @param orgId organization identifier in optional filter
     * @param serialNumberQueryParamOptional Subscription Serial Number In Optional Filter
     * @param startDateStartOptionalQueryParam Start date to begin with in YYYY-MM-DD
     * @param startDateEndOptionalQueryParam Start date to end with in YYYY-MM-DD
     * @param endDateStartOptionalQueryParam End date to begin with in YYYY-MM-DD
     * @param endDateEndOptionalQueryParam End date to end with in YYYY-MM-DD
     * @param quantityQueryParamOptional Quantity In Optional Filter
     * @param subscriptionStateOptionalQueryParam Subscription state
     * @param createdTsStart Filter for created ts start
     * @param createdTsEnd Filter for created ts end
     * @param updatedTsStart Filter for updated ts start
     * @param updatedTsEnd Filter for updated ts end
     * @param chargeIdQueryParamOptional Charge Id In Optional Filter
     * @param datacenterQueryParamOptional Datacenter In Optional Filter
     * @param serviceType Service Type
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllSubscriptionDisplayOperator(sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, orgId?: string, serialNumberQueryParamOptional?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, quantityQueryParamOptional?: number, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, serviceType?: 'VCDR' | 'VMCFS', pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionDisplayPaginatedResponse>;
    public getAllSubscriptionDisplayOperator(sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, orgId?: string, serialNumberQueryParamOptional?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, quantityQueryParamOptional?: number, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, serviceType?: 'VCDR' | 'VMCFS', pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionDisplayPaginatedResponse>>;
    public getAllSubscriptionDisplayOperator(sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, orgId?: string, serialNumberQueryParamOptional?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, quantityQueryParamOptional?: number, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, serviceType?: 'VCDR' | 'VMCFS', pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionDisplayPaginatedResponse>>;
    public getAllSubscriptionDisplayOperator(sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, orgId?: string, serialNumberQueryParamOptional?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, quantityQueryParamOptional?: number, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, serviceType?: 'VCDR' | 'VMCFS', pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getAllSubscriptionDisplayOperator.');
        }
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getAllSubscriptionDisplayOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sortBy');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>idOptionalQueryParam, 'idOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumberQueryParamOptional, 'serial-number-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateStartOptionalQueryParam, 'startDateStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateEndOptionalQueryParam, 'startDateEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateStartOptionalQueryParam, 'endDateStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateEndOptionalQueryParam, 'endDateEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantityQueryParamOptional, 'quantity-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionStateOptionalQueryParam, 'subscriptionStateOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsStart, 'createdTsStart');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsEnd, 'createdTsEnd');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsStart, 'updatedTsStart');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsEnd, 'updatedTsEnd');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>chargeIdQueryParamOptional, 'charge-id-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>datacenterQueryParamOptional, 'datacenter-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/display`;
        return this.httpClient.request<SubscriptionDisplayPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all subscription history.
     * Get all subscription history.
     * @param sortBy Sort the subscription history by this column
     * @param sortByOrder Sort the properties by this order
     * @param idOptionalQueryParam Long ID query param
     * @param serialNumberQueryParamOptional Subscription Serial Number In Optional Filter
     * @param orgId organization identifier in optional filter
     * @param erpIdOptionalQueryParam ERP id query param
     * @param skuInfoOptionalQuerySku Sku Info Primary Key
     * @param quantityQueryParamOptional Quantity In Optional Filter
     * @param startDateStartOptionalQueryParam Start date to begin with in YYYY-MM-DD
     * @param startDateEndOptionalQueryParam Start date to end with in YYYY-MM-DD
     * @param endDateStartOptionalQueryParam End date to begin with in YYYY-MM-DD
     * @param endDateEndOptionalQueryParam End date to end with in YYYY-MM-DD
     * @param subscriptionStateOptionalQueryParam Subscription state
     * @param genCountOptionalQueryParam Gen count
     * @param subscriptionTypeOptionalQueryParam Subscription type In Optional Filter
     * @param effectiveStartDateStartOptionalQueryParam Effective start date to begin with in YYYY-MM-DD
     * @param effectiveStartDateEndOptionalQueryParam Effective start date to end with in YYYY-MM-DD
     * @param effectiveEndDateStartOptionalQueryParam Effective end date to begin with in YYYY-MM-DD
     * @param effectiveEndDateEndOptionalQueryParam Effective end date to end with in YYYY-MM-DD
     * @param effectiveSubscriptionStateOptionalQueryParam Effective subscription state
     * @param effectiveSkuOptionalQueryParam Effective sku
     * @param effectiveQuantityOptionalQueryParam Effective quantity
     * @param provisioningNotificationIdOptionalQueryParam Provisioning notification id
     * @param createdTsStart Filter for created ts start
     * @param createdTsEnd Filter for created ts end
     * @param updatedTsStart Filter for updated ts start
     * @param updatedTsEnd Filter for updated ts end
     * @param emailIdOptionalQueryParam Email id
     * @param chargeIdQueryParamOptional Charge Id In Optional Filter
     * @param datacenterQueryParamOptional Datacenter In Optional Filter
     * @param serviceType Service Type
     * @param subscriptionSourceTypeQueryParamOptional Subscription Source Type In Optional Filter
     * @param saasTransactionId transaction identifier in Optional Filter
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllSubscriptionHistoryOperator(sortBy: 'id' | 'serialNumber' | 'tenantId' | 'erpId' | 'sku' | 'quantity' | 'startDate' | 'endDate' | 'state' | 'genCount' | 'subscriptionType' | 'effectiveStartDate' | 'effectiveEndDate' | 'effectiveState' | 'effectiveSku' | 'effectiveQuantity' | 'provisioningNotificationId' | 'createdAt' | 'updatedAt' | 'emailId', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, serialNumberQueryParamOptional?: string, orgId?: string, erpIdOptionalQueryParam?: string, skuInfoOptionalQuerySku?: string, quantityQueryParamOptional?: number, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, genCountOptionalQueryParam?: number, subscriptionTypeOptionalQueryParam?: SubscriptionTypeEnumV2, effectiveStartDateStartOptionalQueryParam?: string, effectiveStartDateEndOptionalQueryParam?: string, effectiveEndDateStartOptionalQueryParam?: string, effectiveEndDateEndOptionalQueryParam?: string, effectiveSubscriptionStateOptionalQueryParam?: SubscriptionStateEnum, effectiveSkuOptionalQueryParam?: string, effectiveQuantityOptionalQueryParam?: number, provisioningNotificationIdOptionalQueryParam?: number, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, emailIdOptionalQueryParam?: string, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, serviceType?: 'VCDR' | 'VMCFS', subscriptionSourceTypeQueryParamOptional?: string, saasTransactionId?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionHistoryPaginatedResponse>;
    public getAllSubscriptionHistoryOperator(sortBy: 'id' | 'serialNumber' | 'tenantId' | 'erpId' | 'sku' | 'quantity' | 'startDate' | 'endDate' | 'state' | 'genCount' | 'subscriptionType' | 'effectiveStartDate' | 'effectiveEndDate' | 'effectiveState' | 'effectiveSku' | 'effectiveQuantity' | 'provisioningNotificationId' | 'createdAt' | 'updatedAt' | 'emailId', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, serialNumberQueryParamOptional?: string, orgId?: string, erpIdOptionalQueryParam?: string, skuInfoOptionalQuerySku?: string, quantityQueryParamOptional?: number, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, genCountOptionalQueryParam?: number, subscriptionTypeOptionalQueryParam?: SubscriptionTypeEnumV2, effectiveStartDateStartOptionalQueryParam?: string, effectiveStartDateEndOptionalQueryParam?: string, effectiveEndDateStartOptionalQueryParam?: string, effectiveEndDateEndOptionalQueryParam?: string, effectiveSubscriptionStateOptionalQueryParam?: SubscriptionStateEnum, effectiveSkuOptionalQueryParam?: string, effectiveQuantityOptionalQueryParam?: number, provisioningNotificationIdOptionalQueryParam?: number, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, emailIdOptionalQueryParam?: string, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, serviceType?: 'VCDR' | 'VMCFS', subscriptionSourceTypeQueryParamOptional?: string, saasTransactionId?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionHistoryPaginatedResponse>>;
    public getAllSubscriptionHistoryOperator(sortBy: 'id' | 'serialNumber' | 'tenantId' | 'erpId' | 'sku' | 'quantity' | 'startDate' | 'endDate' | 'state' | 'genCount' | 'subscriptionType' | 'effectiveStartDate' | 'effectiveEndDate' | 'effectiveState' | 'effectiveSku' | 'effectiveQuantity' | 'provisioningNotificationId' | 'createdAt' | 'updatedAt' | 'emailId', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, serialNumberQueryParamOptional?: string, orgId?: string, erpIdOptionalQueryParam?: string, skuInfoOptionalQuerySku?: string, quantityQueryParamOptional?: number, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, genCountOptionalQueryParam?: number, subscriptionTypeOptionalQueryParam?: SubscriptionTypeEnumV2, effectiveStartDateStartOptionalQueryParam?: string, effectiveStartDateEndOptionalQueryParam?: string, effectiveEndDateStartOptionalQueryParam?: string, effectiveEndDateEndOptionalQueryParam?: string, effectiveSubscriptionStateOptionalQueryParam?: SubscriptionStateEnum, effectiveSkuOptionalQueryParam?: string, effectiveQuantityOptionalQueryParam?: number, provisioningNotificationIdOptionalQueryParam?: number, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, emailIdOptionalQueryParam?: string, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, serviceType?: 'VCDR' | 'VMCFS', subscriptionSourceTypeQueryParamOptional?: string, saasTransactionId?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionHistoryPaginatedResponse>>;
    public getAllSubscriptionHistoryOperator(sortBy: 'id' | 'serialNumber' | 'tenantId' | 'erpId' | 'sku' | 'quantity' | 'startDate' | 'endDate' | 'state' | 'genCount' | 'subscriptionType' | 'effectiveStartDate' | 'effectiveEndDate' | 'effectiveState' | 'effectiveSku' | 'effectiveQuantity' | 'provisioningNotificationId' | 'createdAt' | 'updatedAt' | 'emailId', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, serialNumberQueryParamOptional?: string, orgId?: string, erpIdOptionalQueryParam?: string, skuInfoOptionalQuerySku?: string, quantityQueryParamOptional?: number, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, genCountOptionalQueryParam?: number, subscriptionTypeOptionalQueryParam?: SubscriptionTypeEnumV2, effectiveStartDateStartOptionalQueryParam?: string, effectiveStartDateEndOptionalQueryParam?: string, effectiveEndDateStartOptionalQueryParam?: string, effectiveEndDateEndOptionalQueryParam?: string, effectiveSubscriptionStateOptionalQueryParam?: SubscriptionStateEnum, effectiveSkuOptionalQueryParam?: string, effectiveQuantityOptionalQueryParam?: number, provisioningNotificationIdOptionalQueryParam?: number, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, emailIdOptionalQueryParam?: string, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, serviceType?: 'VCDR' | 'VMCFS', subscriptionSourceTypeQueryParamOptional?: string, saasTransactionId?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getAllSubscriptionHistoryOperator.');
        }
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getAllSubscriptionHistoryOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sortBy');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>idOptionalQueryParam, 'idOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumberQueryParamOptional, 'serial-number-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>erpIdOptionalQueryParam, 'erpIdOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>skuInfoOptionalQuerySku, 'sku-info-optional-query-sku');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantityQueryParamOptional, 'quantity-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateStartOptionalQueryParam, 'startDateStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateEndOptionalQueryParam, 'startDateEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateStartOptionalQueryParam, 'endDateStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateEndOptionalQueryParam, 'endDateEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionStateOptionalQueryParam, 'subscriptionStateOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>genCountOptionalQueryParam, 'genCountOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionTypeOptionalQueryParam, 'subscriptionTypeOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>effectiveStartDateStartOptionalQueryParam, 'effectiveStartDateStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>effectiveStartDateEndOptionalQueryParam, 'effectiveStartDateEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>effectiveEndDateStartOptionalQueryParam, 'effectiveEndDateStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>effectiveEndDateEndOptionalQueryParam, 'effectiveEndDateEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>effectiveSubscriptionStateOptionalQueryParam, 'effectiveSubscriptionStateOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>effectiveSkuOptionalQueryParam, 'effectiveSkuOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>effectiveQuantityOptionalQueryParam, 'effectiveQuantityOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>provisioningNotificationIdOptionalQueryParam, 'provisioningNotificationIdOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsStart, 'createdTsStart');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsEnd, 'createdTsEnd');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsStart, 'updatedTsStart');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsEnd, 'updatedTsEnd');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>emailIdOptionalQueryParam, 'emailIdOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>chargeIdQueryParamOptional, 'charge-id-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>datacenterQueryParamOptional, 'datacenter-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionSourceTypeQueryParamOptional, 'subscription-source-type-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>saasTransactionId, 'saas-transaction-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/history`;
        return this.httpClient.request<SubscriptionHistoryPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all tenants.
     * Get all tenants.
     * @param sortBy Sort the tenants by this column
     * @param sortByOrder Sort the properties by this order
     * @param idOptionalQueryParam Long ID query param
     * @param orgId organization identifier in optional filter
     * @param erpIdOptionalQueryParam ERP id query param
     * @param hasDeploymentOptionalQueryParam hasDeploymentOptionalQueryParam
     * @param vlrOrgSummaryLastProcessingDtStartOptionalQueryParam vlrOrgSummaryLastProcessingDtStartOptionalQueryParam
     * @param vlrOrgSummaryLastProcessingDtEndOptionalQueryParam vlrOrgSummaryLastProcessingDtEndOptionalQueryParam
     * @param vmcOrgSummaryLastProcessingDtStartOptionalQueryParam vmcOrgSummaryLastProcessingDtStartOptionalQueryParam
     * @param vmcOrgSummaryLastProcessingDtEndOptionalQueryParam vmcOrgSummaryLastProcessingDtEndOptionalQueryParam
     * @param lastVmcRefreshDtStartOptionalQueryParam lastVmcRefreshDtStartOptionalQueryParam
     * @param lastVmcRefreshDtEndOptionalQueryParam lastVmcRefreshDtEndOptionalQueryParam
     * @param createdTsStart Filter for created ts start
     * @param createdTsEnd Filter for created ts end
     * @param updatedTsStart Filter for updated ts start
     * @param updatedTsEnd Filter for updated ts end
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllTenantsOperator(sortBy: 'id' | 'orgId' | 'erpId' | 'hasDeployment' | 'vlrOrgSummaryLastProcessingDt' | 'vmcOrgSummaryLastProcessingDt' | 'lastVmcRefreshDt' | 'createdAt' | 'updatedAt', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, orgId?: string, erpIdOptionalQueryParam?: string, hasDeploymentOptionalQueryParam?: boolean, vlrOrgSummaryLastProcessingDtStartOptionalQueryParam?: string, vlrOrgSummaryLastProcessingDtEndOptionalQueryParam?: string, vmcOrgSummaryLastProcessingDtStartOptionalQueryParam?: string, vmcOrgSummaryLastProcessingDtEndOptionalQueryParam?: string, lastVmcRefreshDtStartOptionalQueryParam?: string, lastVmcRefreshDtEndOptionalQueryParam?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TenantPaginatedResponse>;
    public getAllTenantsOperator(sortBy: 'id' | 'orgId' | 'erpId' | 'hasDeployment' | 'vlrOrgSummaryLastProcessingDt' | 'vmcOrgSummaryLastProcessingDt' | 'lastVmcRefreshDt' | 'createdAt' | 'updatedAt', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, orgId?: string, erpIdOptionalQueryParam?: string, hasDeploymentOptionalQueryParam?: boolean, vlrOrgSummaryLastProcessingDtStartOptionalQueryParam?: string, vlrOrgSummaryLastProcessingDtEndOptionalQueryParam?: string, vmcOrgSummaryLastProcessingDtStartOptionalQueryParam?: string, vmcOrgSummaryLastProcessingDtEndOptionalQueryParam?: string, lastVmcRefreshDtStartOptionalQueryParam?: string, lastVmcRefreshDtEndOptionalQueryParam?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TenantPaginatedResponse>>;
    public getAllTenantsOperator(sortBy: 'id' | 'orgId' | 'erpId' | 'hasDeployment' | 'vlrOrgSummaryLastProcessingDt' | 'vmcOrgSummaryLastProcessingDt' | 'lastVmcRefreshDt' | 'createdAt' | 'updatedAt', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, orgId?: string, erpIdOptionalQueryParam?: string, hasDeploymentOptionalQueryParam?: boolean, vlrOrgSummaryLastProcessingDtStartOptionalQueryParam?: string, vlrOrgSummaryLastProcessingDtEndOptionalQueryParam?: string, vmcOrgSummaryLastProcessingDtStartOptionalQueryParam?: string, vmcOrgSummaryLastProcessingDtEndOptionalQueryParam?: string, lastVmcRefreshDtStartOptionalQueryParam?: string, lastVmcRefreshDtEndOptionalQueryParam?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TenantPaginatedResponse>>;
    public getAllTenantsOperator(sortBy: 'id' | 'orgId' | 'erpId' | 'hasDeployment' | 'vlrOrgSummaryLastProcessingDt' | 'vmcOrgSummaryLastProcessingDt' | 'lastVmcRefreshDt' | 'createdAt' | 'updatedAt', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, orgId?: string, erpIdOptionalQueryParam?: string, hasDeploymentOptionalQueryParam?: boolean, vlrOrgSummaryLastProcessingDtStartOptionalQueryParam?: string, vlrOrgSummaryLastProcessingDtEndOptionalQueryParam?: string, vmcOrgSummaryLastProcessingDtStartOptionalQueryParam?: string, vmcOrgSummaryLastProcessingDtEndOptionalQueryParam?: string, lastVmcRefreshDtStartOptionalQueryParam?: string, lastVmcRefreshDtEndOptionalQueryParam?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getAllTenantsOperator.');
        }
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getAllTenantsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sortBy');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>idOptionalQueryParam, 'idOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>erpIdOptionalQueryParam, 'erpIdOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>hasDeploymentOptionalQueryParam, 'hasDeploymentOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlrOrgSummaryLastProcessingDtStartOptionalQueryParam, 'vlrOrgSummaryLastProcessingDtStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlrOrgSummaryLastProcessingDtEndOptionalQueryParam, 'vlrOrgSummaryLastProcessingDtEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vmcOrgSummaryLastProcessingDtStartOptionalQueryParam, 'vmcOrgSummaryLastProcessingDtStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vmcOrgSummaryLastProcessingDtEndOptionalQueryParam, 'vmcOrgSummaryLastProcessingDtEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>lastVmcRefreshDtStartOptionalQueryParam, 'lastVmcRefreshDtStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>lastVmcRefreshDtEndOptionalQueryParam, 'lastVmcRefreshDtEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsStart, 'createdTsStart');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsEnd, 'createdTsEnd');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsStart, 'updatedTsStart');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsEnd, 'updatedTsEnd');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/tenant`;
        return this.httpClient.request<TenantPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all billing cross org processed subscription by filters
     * Get all billing cross org processed subscription by filter
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the billing cross org processed subscription by this column
     * @param datacenterQueryParamOptional Datacenter In Optional Filter
     * @param chargeIdQueryParamOptional Charge Id In Optional Filter
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNoNullableOptional Page Number (It starts from 0)
     * @param pageSizeNullableOptional Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCrossOrgProcessedSubscriptions(sortByOrder: 'ASC' | 'DESC', sortBy: 'effectiveDate' | 'datacenter' | 'chargeId' | 'quantity' | 'createdTs' | 'updatedTs', datacenterQueryParamOptional?: string, chargeIdQueryParamOptional?: string, startTime?: string, endTime?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<CrossOrgProcessedSubscriptionPaginatedResponse>;
    public getCrossOrgProcessedSubscriptions(sortByOrder: 'ASC' | 'DESC', sortBy: 'effectiveDate' | 'datacenter' | 'chargeId' | 'quantity' | 'createdTs' | 'updatedTs', datacenterQueryParamOptional?: string, chargeIdQueryParamOptional?: string, startTime?: string, endTime?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CrossOrgProcessedSubscriptionPaginatedResponse>>;
    public getCrossOrgProcessedSubscriptions(sortByOrder: 'ASC' | 'DESC', sortBy: 'effectiveDate' | 'datacenter' | 'chargeId' | 'quantity' | 'createdTs' | 'updatedTs', datacenterQueryParamOptional?: string, chargeIdQueryParamOptional?: string, startTime?: string, endTime?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CrossOrgProcessedSubscriptionPaginatedResponse>>;
    public getCrossOrgProcessedSubscriptions(sortByOrder: 'ASC' | 'DESC', sortBy: 'effectiveDate' | 'datacenter' | 'chargeId' | 'quantity' | 'createdTs' | 'updatedTs', datacenterQueryParamOptional?: string, chargeIdQueryParamOptional?: string, startTime?: string, endTime?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getCrossOrgProcessedSubscriptions.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getCrossOrgProcessedSubscriptions.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>datacenterQueryParamOptional, 'datacenter-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>chargeIdQueryParamOptional, 'charge-id-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNoNullableOptional, 'page-no-nullable-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSizeNullableOptional, 'page-size-nullable-optional');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/cross-org-processed-subscriptions`;
        return this.httpClient.request<CrossOrgProcessedSubscriptionPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all billing processed subscription by filters
     * Get all billing processed subscription by filter
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the billing processed subscription by this column
     * @param processedSubscriptionOptionalQueryId Processed Subscription Primary Key In Optional Filter
     * @param orgId organization identifier in optional filter
     * @param datacenterQueryParamOptional Datacenter In Optional Filter
     * @param chargeIdQueryParamOptional Charge Id In Optional Filter
     * @param quantityQueryParamOptional Quantity In Optional Filter
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProcessedSubscription(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'seller' | 'datacenter' | 'chargeId' | 'quantity' | 'fromTs' | 'toTs' | 'createdTs' | 'updatedTs', processedSubscriptionOptionalQueryId?: number, orgId?: string, datacenterQueryParamOptional?: string, chargeIdQueryParamOptional?: string, quantityQueryParamOptional?: number, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProcessedSubscriptionPaginatedResponse>;
    public getProcessedSubscription(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'seller' | 'datacenter' | 'chargeId' | 'quantity' | 'fromTs' | 'toTs' | 'createdTs' | 'updatedTs', processedSubscriptionOptionalQueryId?: number, orgId?: string, datacenterQueryParamOptional?: string, chargeIdQueryParamOptional?: string, quantityQueryParamOptional?: number, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProcessedSubscriptionPaginatedResponse>>;
    public getProcessedSubscription(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'seller' | 'datacenter' | 'chargeId' | 'quantity' | 'fromTs' | 'toTs' | 'createdTs' | 'updatedTs', processedSubscriptionOptionalQueryId?: number, orgId?: string, datacenterQueryParamOptional?: string, chargeIdQueryParamOptional?: string, quantityQueryParamOptional?: number, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProcessedSubscriptionPaginatedResponse>>;
    public getProcessedSubscription(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'seller' | 'datacenter' | 'chargeId' | 'quantity' | 'fromTs' | 'toTs' | 'createdTs' | 'updatedTs', processedSubscriptionOptionalQueryId?: number, orgId?: string, datacenterQueryParamOptional?: string, chargeIdQueryParamOptional?: string, quantityQueryParamOptional?: number, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getProcessedSubscription.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getProcessedSubscription.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>processedSubscriptionOptionalQueryId, 'processed-subscription-optional-query-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>datacenterQueryParamOptional, 'datacenter-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>chargeIdQueryParamOptional, 'charge-id-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantityQueryParamOptional, 'quantity-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/processed-subscription`;
        return this.httpClient.request<ProcessedSubscriptionPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all v4 raw subscriptions by filters
     * Get all v4 raw subscriptions by filters
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the billing V4 raw subscription by this column
     * @param subscriptionSourceTypeQueryParamOptional Subscription Source Type In Optional Filter
     * @param serialNumberQueryParamOptional Subscription Serial Number In Optional Filter
     * @param subscriptionIdQueryParamOptional Subscription UUID
     * @param v3SubscriptionIdQueryParamOptional v3Subscription UUID
     * @param orgId organization identifier in optional filter
     * @param serviceType Service Type
     * @param seller Seller Of Record
     * @param datacenterQueryParamOptional Datacenter In Optional Filter
     * @param v4SubscriptionTypeQueryParamOptional V4 Subscription type In Optional Filter
     * @param subscriptionTypeQueryParamOptional Subscription type In Optional Filter
     * @param subscriptionStatusQueryParamOptional Subscription status In Optional Filter
     * @param derivedSubscriptionStatusQueryParamOptional Derived subscription status In Optional Filter
     * @param skuInfoOptionalQuerySku Sku Info Primary Key
     * @param chargeIdQueryParamOptional Charge Id In Optional Filter
     * @param quantityQueryParamOptional Quantity In Optional Filter
     * @param billingAccountIdQueryOptional Billing Account Id In Optional Filter
     * @param billingEngineSubscriptionIdQueryParamOptional Billing Engine Subscription Id In Optional Filter
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getV4RawSubscriptionsOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'subscriptionSourceType' | 'serialNumber' | 'subscriptionId' | 'v3SubscriptionId' | 'orgId' | 'serviceType' | 'seller' | 'datacenter' | 'v4SubscriptionType' | 'subscriptionType' | 'subscriptionStatus' | 'derivedSubscriptionStatus' | 'sku' | 'chargeId' | 'quantity' | 'billingAccountId' | 'billingEngineSubscriptionId' | 'startTs' | 'endTs' | 'updatedTs', subscriptionSourceTypeQueryParamOptional?: string, serialNumberQueryParamOptional?: string, subscriptionIdQueryParamOptional?: string, v3SubscriptionIdQueryParamOptional?: string, orgId?: string, serviceType?: 'VCDR' | 'VMCFS', seller?: string, datacenterQueryParamOptional?: string, v4SubscriptionTypeQueryParamOptional?: string, subscriptionTypeQueryParamOptional?: string, subscriptionStatusQueryParamOptional?: string, derivedSubscriptionStatusQueryParamOptional?: string, skuInfoOptionalQuerySku?: string, chargeIdQueryParamOptional?: string, quantityQueryParamOptional?: number, billingAccountIdQueryOptional?: string, billingEngineSubscriptionIdQueryParamOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RawSubscriptionV4PaginatedResponse>;
    public getV4RawSubscriptionsOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'subscriptionSourceType' | 'serialNumber' | 'subscriptionId' | 'v3SubscriptionId' | 'orgId' | 'serviceType' | 'seller' | 'datacenter' | 'v4SubscriptionType' | 'subscriptionType' | 'subscriptionStatus' | 'derivedSubscriptionStatus' | 'sku' | 'chargeId' | 'quantity' | 'billingAccountId' | 'billingEngineSubscriptionId' | 'startTs' | 'endTs' | 'updatedTs', subscriptionSourceTypeQueryParamOptional?: string, serialNumberQueryParamOptional?: string, subscriptionIdQueryParamOptional?: string, v3SubscriptionIdQueryParamOptional?: string, orgId?: string, serviceType?: 'VCDR' | 'VMCFS', seller?: string, datacenterQueryParamOptional?: string, v4SubscriptionTypeQueryParamOptional?: string, subscriptionTypeQueryParamOptional?: string, subscriptionStatusQueryParamOptional?: string, derivedSubscriptionStatusQueryParamOptional?: string, skuInfoOptionalQuerySku?: string, chargeIdQueryParamOptional?: string, quantityQueryParamOptional?: number, billingAccountIdQueryOptional?: string, billingEngineSubscriptionIdQueryParamOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RawSubscriptionV4PaginatedResponse>>;
    public getV4RawSubscriptionsOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'subscriptionSourceType' | 'serialNumber' | 'subscriptionId' | 'v3SubscriptionId' | 'orgId' | 'serviceType' | 'seller' | 'datacenter' | 'v4SubscriptionType' | 'subscriptionType' | 'subscriptionStatus' | 'derivedSubscriptionStatus' | 'sku' | 'chargeId' | 'quantity' | 'billingAccountId' | 'billingEngineSubscriptionId' | 'startTs' | 'endTs' | 'updatedTs', subscriptionSourceTypeQueryParamOptional?: string, serialNumberQueryParamOptional?: string, subscriptionIdQueryParamOptional?: string, v3SubscriptionIdQueryParamOptional?: string, orgId?: string, serviceType?: 'VCDR' | 'VMCFS', seller?: string, datacenterQueryParamOptional?: string, v4SubscriptionTypeQueryParamOptional?: string, subscriptionTypeQueryParamOptional?: string, subscriptionStatusQueryParamOptional?: string, derivedSubscriptionStatusQueryParamOptional?: string, skuInfoOptionalQuerySku?: string, chargeIdQueryParamOptional?: string, quantityQueryParamOptional?: number, billingAccountIdQueryOptional?: string, billingEngineSubscriptionIdQueryParamOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RawSubscriptionV4PaginatedResponse>>;
    public getV4RawSubscriptionsOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'subscriptionSourceType' | 'serialNumber' | 'subscriptionId' | 'v3SubscriptionId' | 'orgId' | 'serviceType' | 'seller' | 'datacenter' | 'v4SubscriptionType' | 'subscriptionType' | 'subscriptionStatus' | 'derivedSubscriptionStatus' | 'sku' | 'chargeId' | 'quantity' | 'billingAccountId' | 'billingEngineSubscriptionId' | 'startTs' | 'endTs' | 'updatedTs', subscriptionSourceTypeQueryParamOptional?: string, serialNumberQueryParamOptional?: string, subscriptionIdQueryParamOptional?: string, v3SubscriptionIdQueryParamOptional?: string, orgId?: string, serviceType?: 'VCDR' | 'VMCFS', seller?: string, datacenterQueryParamOptional?: string, v4SubscriptionTypeQueryParamOptional?: string, subscriptionTypeQueryParamOptional?: string, subscriptionStatusQueryParamOptional?: string, derivedSubscriptionStatusQueryParamOptional?: string, skuInfoOptionalQuerySku?: string, chargeIdQueryParamOptional?: string, quantityQueryParamOptional?: number, billingAccountIdQueryOptional?: string, billingEngineSubscriptionIdQueryParamOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getV4RawSubscriptionsOperator.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getV4RawSubscriptionsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionSourceTypeQueryParamOptional, 'subscription-source-type-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumberQueryParamOptional, 'serial-number-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionIdQueryParamOptional, 'subscription-id-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>v3SubscriptionIdQueryParamOptional, 'v3-subscription-id-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>seller, 'seller');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>datacenterQueryParamOptional, 'datacenter-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>v4SubscriptionTypeQueryParamOptional, 'v4-subscription-type-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionTypeQueryParamOptional, 'subscription-type-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionStatusQueryParamOptional, 'subscription-status-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>derivedSubscriptionStatusQueryParamOptional, 'derived-subscription-status-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>skuInfoOptionalQuerySku, 'sku-info-optional-query-sku');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>chargeIdQueryParamOptional, 'charge-id-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantityQueryParamOptional, 'quantity-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingAccountIdQueryOptional, 'billing-account-id-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingEngineSubscriptionIdQueryParamOptional, 'billing-engine-subscription-id-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/v4/raw-subscription`;
        return this.httpClient.request<RawSubscriptionV4PaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch billing processed subscription by id
     * Find and patch billing processed subscription by id
     * @param processedSubscriptionQueryId Processed Subscription Primary Key
     * @param processedSubscriptionPatchSpec Billing Processed Subscription patch spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchProcessedSubscription(processedSubscriptionQueryId: number, processedSubscriptionPatchSpec: ProcessedSubscriptionPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProcessedSubscriptionResponse>;
    public patchProcessedSubscription(processedSubscriptionQueryId: number, processedSubscriptionPatchSpec: ProcessedSubscriptionPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProcessedSubscriptionResponse>>;
    public patchProcessedSubscription(processedSubscriptionQueryId: number, processedSubscriptionPatchSpec: ProcessedSubscriptionPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProcessedSubscriptionResponse>>;
    public patchProcessedSubscription(processedSubscriptionQueryId: number, processedSubscriptionPatchSpec: ProcessedSubscriptionPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (processedSubscriptionQueryId === null || processedSubscriptionQueryId === undefined) {
            throw new Error('Required parameter processedSubscriptionQueryId was null or undefined when calling patchProcessedSubscription.');
        }
        if (processedSubscriptionPatchSpec === null || processedSubscriptionPatchSpec === undefined) {
            throw new Error('Required parameter processedSubscriptionPatchSpec was null or undefined when calling patchProcessedSubscription.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>processedSubscriptionQueryId, 'processed-subscription-query-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/processed-subscription`;
        return this.httpClient.request<ProcessedSubscriptionResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: processedSubscriptionPatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a subscription display.
     * Update a subscription display.
     * @param subscriptionDisplayUpdatePatchSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchSubscriptionDisplayOperator(subscriptionDisplayUpdatePatchSpec?: SubscriptionDisplayUpdatePatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionDisplay>;
    public patchSubscriptionDisplayOperator(subscriptionDisplayUpdatePatchSpec?: SubscriptionDisplayUpdatePatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionDisplay>>;
    public patchSubscriptionDisplayOperator(subscriptionDisplayUpdatePatchSpec?: SubscriptionDisplayUpdatePatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionDisplay>>;
    public patchSubscriptionDisplayOperator(subscriptionDisplayUpdatePatchSpec?: SubscriptionDisplayUpdatePatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/display`;
        return this.httpClient.request<SubscriptionDisplay>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: subscriptionDisplayUpdatePatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a subscription history.
     * Update a subscription history.
     * @param subscriptionHistoryUpdatePatchSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchSubscriptionHistoryOperator(subscriptionHistoryUpdatePatchSpec?: SubscriptionHistoryUpdatePatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionHistory>;
    public patchSubscriptionHistoryOperator(subscriptionHistoryUpdatePatchSpec?: SubscriptionHistoryUpdatePatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionHistory>>;
    public patchSubscriptionHistoryOperator(subscriptionHistoryUpdatePatchSpec?: SubscriptionHistoryUpdatePatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionHistory>>;
    public patchSubscriptionHistoryOperator(subscriptionHistoryUpdatePatchSpec?: SubscriptionHistoryUpdatePatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/history`;
        return this.httpClient.request<SubscriptionHistory>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: subscriptionHistoryUpdatePatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a tenant.
     * Update a tenant.
     * @param tenantUpdatePatchSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchTenantOperator(tenantUpdatePatchSpec?: TenantUpdatePatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Tenant>;
    public patchTenantOperator(tenantUpdatePatchSpec?: TenantUpdatePatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Tenant>>;
    public patchTenantOperator(tenantUpdatePatchSpec?: TenantUpdatePatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Tenant>>;
    public patchTenantOperator(tenantUpdatePatchSpec?: TenantUpdatePatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/tenant`;
        return this.httpClient.request<Tenant>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tenantUpdatePatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch v4 raw subscription by id and data source
     * Find and patch v4 raw subscription by id and data source
     * @param rawSubscriptionV4PatchSpec V4 raw subscription patch Spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchV4RawSubscriptionOperator(rawSubscriptionV4PatchSpec: RawSubscriptionV4PatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RawSubscriptionV4Response>;
    public patchV4RawSubscriptionOperator(rawSubscriptionV4PatchSpec: RawSubscriptionV4PatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RawSubscriptionV4Response>>;
    public patchV4RawSubscriptionOperator(rawSubscriptionV4PatchSpec: RawSubscriptionV4PatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RawSubscriptionV4Response>>;
    public patchV4RawSubscriptionOperator(rawSubscriptionV4PatchSpec: RawSubscriptionV4PatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rawSubscriptionV4PatchSpec === null || rawSubscriptionV4PatchSpec === undefined) {
            throw new Error('Required parameter rawSubscriptionV4PatchSpec was null or undefined when calling patchV4RawSubscriptionOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/v4/raw-subscription`;
        return this.httpClient.request<RawSubscriptionV4Response>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rawSubscriptionV4PatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create billing processed subscription
     * Create new billing processed subscription
     * @param processedSubscriptionPostSpec Billing processed subscription post spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postProcessedSubscription(processedSubscriptionPostSpec: ProcessedSubscriptionPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProcessedSubscriptionResponse>;
    public postProcessedSubscription(processedSubscriptionPostSpec: ProcessedSubscriptionPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProcessedSubscriptionResponse>>;
    public postProcessedSubscription(processedSubscriptionPostSpec: ProcessedSubscriptionPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProcessedSubscriptionResponse>>;
    public postProcessedSubscription(processedSubscriptionPostSpec: ProcessedSubscriptionPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (processedSubscriptionPostSpec === null || processedSubscriptionPostSpec === undefined) {
            throw new Error('Required parameter processedSubscriptionPostSpec was null or undefined when calling postProcessedSubscription.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/processed-subscription`;
        return this.httpClient.request<ProcessedSubscriptionResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: processedSubscriptionPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create v4 raw subscription
     * Create new v4 raw subscription
     * @param rawSubscriptionV4PostSpec V4 raw subscription post spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postV4RawSubscriptionOperator(rawSubscriptionV4PostSpec: RawSubscriptionV4PostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RawSubscriptionV4Response>;
    public postV4RawSubscriptionOperator(rawSubscriptionV4PostSpec: RawSubscriptionV4PostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RawSubscriptionV4Response>>;
    public postV4RawSubscriptionOperator(rawSubscriptionV4PostSpec: RawSubscriptionV4PostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RawSubscriptionV4Response>>;
    public postV4RawSubscriptionOperator(rawSubscriptionV4PostSpec: RawSubscriptionV4PostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rawSubscriptionV4PostSpec === null || rawSubscriptionV4PostSpec === undefined) {
            throw new Error('Required parameter rawSubscriptionV4PostSpec was null or undefined when calling postV4RawSubscriptionOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/v4/raw-subscription`;
        return this.httpClient.request<RawSubscriptionV4Response>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rawSubscriptionV4PostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
